var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9932 22C4.91153 21.9973 -0.00269827 17.0739 1.11155e-06 10.9872C0.0027005 4.90719 4.92638 -0.00404633 11.0162 2.5016e-06C17.0939 0.00405133 22.0054 4.93148 22 11.0209C21.9959 17.0874 17.0682 22.0014 10.9919 22H10.9932ZM1.77215 11.0047C1.7735 16.0793 5.91975 20.2253 10.9959 20.2266C16.0816 20.228 20.2292 16.0793 20.2278 10.9939C20.2252 5.91804 16.0802 1.77204 11.004 1.77204C5.9184 1.77204 1.7708 5.91939 1.77215 11.0047Z",
    fill: "#FF9516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4762 8.36855C10.4766 8.36762 10.4768 8.36663 10.4768 8.36563C10.4768 7.30073 10.4744 6.23583 10.4768 5.17093C10.4791 4.43356 11.0611 3.97376 11.5871 4.29478C11.8939 4.48122 12.0164 4.80225 12.0164 5.20738C12.0152 7.10408 12.0175 9.00218 12.0117 10.8989C12.0117 11.0825 12.0572 11.1905 12.182 11.2956C13.2411 12.1942 14.2955 13.1012 15.3499 14.0082C15.7219 14.3278 15.8199 14.8605 15.5913 15.2909C15.351 15.7423 14.8647 15.8516 14.4844 15.5292C13.647 14.8156 12.8118 14.0979 11.9767 13.3816C11.5988 13.0577 11.2232 12.7283 10.8418 12.4087C10.5899 12.197 10.4756 11.911 10.4756 11.5465C10.4768 10.4886 10.4756 9.42936 10.4756 8.37147C10.4756 8.37047 10.4758 8.36947 10.4762 8.36855Z",
    fill: "#FF9516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.83ad0815f24875939d9db41299c1b8eb.svg";
export { ForwardRef as ReactComponent };